export const appConfig = {
  candidateBase: "https://candidate.hire3x.com/builder",
  websiteBase: "https://hire3x.com",
  trainingBase: "https://candidate.hire3x.com/training",
  loginBase: "https://app.hire3x.com",
  recruitmentBase: "https://recruitment.hire3x.com",
  assessmentBase: "https://judge.hire3x.com",
  trainingAdminBase: "https://trainingadmin.hire3x.com",
};
